var map = {
	"./account.svg": [
		1631,
		71
	],
	"./afternoon.svg": [
		1632,
		72
	],
	"./afterpay.svg": [
		1633,
		73
	],
	"./alert.svg": [
		1634,
		74
	],
	"./apple-store-white.svg": [
		1635,
		76
	],
	"./apple-store.svg": [
		1636,
		75
	],
	"./arrow-diagonal.svg": [
		1637,
		77
	],
	"./arrow-down.svg": [
		1638,
		78
	],
	"./arrow-left.svg": [
		1639,
		79
	],
	"./arrow-pointing-right.svg": [
		1640,
		80
	],
	"./arrow-right.svg": [
		1641,
		81
	],
	"./arrow-up.svg": [
		1642,
		82
	],
	"./ban-icon.svg": [
		1643,
		83
	],
	"./blowdryer.svg": [
		1644,
		84
	],
	"./boxed-calendar.svg": [
		1645,
		85
	],
	"./boxed-check.svg": [
		1646,
		86
	],
	"./boxed-clock.svg": [
		1647,
		87
	],
	"./boxed-drop.svg": [
		1648,
		88
	],
	"./boxed-dropper.svg": [
		1649,
		89
	],
	"./boxed-shop.svg": [
		1650,
		90
	],
	"./calendar-refresh.svg": [
		1651,
		91
	],
	"./calendar.svg": [
		1652,
		92
	],
	"./camera-front.svg": [
		1653,
		93
	],
	"./camera.svg": [
		1654,
		94
	],
	"./caret-down.svg": [
		1655,
		95
	],
	"./caret-rounded.svg": [
		1656,
		96
	],
	"./chair.svg": [
		1657,
		97
	],
	"./chat-2.svg": [
		1658,
		98
	],
	"./chat.svg": [
		1659,
		99
	],
	"./check-circle-empty.svg": [
		1660,
		100
	],
	"./check-circle-filled.svg": [
		1661,
		101
	],
	"./check-circle-solid.svg": [
		1662,
		102
	],
	"./check-circle.svg": [
		1663,
		103
	],
	"./check-icon.svg": [
		1664,
		104
	],
	"./checkmark.svg": [
		1665,
		105
	],
	"./circle-arrow.svg": [
		1666,
		106
	],
	"./circle-camera.svg": [
		1667,
		107
	],
	"./clock.svg": [
		1668,
		108
	],
	"./coily-hair.svg": [
		1669,
		109
	],
	"./color-kit.svg": [
		1670,
		110
	],
	"./color-plus-line-icon.svg": [
		1671,
		111
	],
	"./colorwonder-logo.svg": [
		1672,
		112
	],
	"./comb.svg": [
		1673,
		113
	],
	"./cross-icon.svg": [
		1674,
		114
	],
	"./curly-hair.svg": [
		1675,
		115
	],
	"./cw-check.svg": [
		1676,
		116
	],
	"./cw-message.svg": [
		1677,
		117
	],
	"./dollar-circle.svg": [
		1678,
		118
	],
	"./doordash.svg": [
		1679,
		119
	],
	"./email.svg": [
		1680,
		120
	],
	"./enlarge.svg": [
		1681,
		121
	],
	"./evening.svg": [
		1682,
		122
	],
	"./filters.svg": [
		1683,
		123
	],
	"./gift.svg": [
		1684,
		124
	],
	"./google-play-white.svg": [
		1685,
		126
	],
	"./google-play.svg": [
		1686,
		125
	],
	"./green-check.svg": [
		1687,
		127
	],
	"./hair-color-circles.svg": [
		1688,
		128
	],
	"./hair.svg": [
		1689,
		129
	],
	"./heart-ribbon.svg": [
		1690,
		130
	],
	"./heart.svg": [
		1691,
		131
	],
	"./info-icon.svg": [
		1692,
		132
	],
	"./info.svg": [
		1693,
		133
	],
	"./left-pointing-arrow.svg": [
		1694,
		134
	],
	"./less.svg": [
		1695,
		135
	],
	"./light-bulb.svg": [
		1696,
		136
	],
	"./location.svg": [
		1697,
		137
	],
	"./logout.svg": [
		1698,
		138
	],
	"./mail-circle.svg": [
		1699,
		139
	],
	"./map-circle.svg": [
		1700,
		140
	],
	"./map-marker-base.svg": [
		1701,
		141
	],
	"./map-marker-inverted.svg": [
		1702,
		142
	],
	"./map-marker.svg": [
		1703,
		143
	],
	"./mdsnrd-vertical.svg": [
		1704,
		144
	],
	"./mic-off.svg": [
		1705,
		145
	],
	"./mic.svg": [
		1706,
		146
	],
	"./mirror.svg": [
		1707,
		147
	],
	"./money-back-redesign.svg": [
		1708,
		148
	],
	"./money-back.svg": [
		1709,
		149
	],
	"./money-hand.svg": [
		1710,
		150
	],
	"./more.svg": [
		1711,
		151
	],
	"./morning.svg": [
		1712,
		152
	],
	"./mr-haircolor-logo.svg": [
		1713,
		153
	],
	"./mr-icon-chat.svg": [
		1714,
		154
	],
	"./mr-logo.svg": [
		1715,
		155
	],
	"./mr-mister-logo.svg": [
		1716,
		156
	],
	"./pause.svg": [
		1717,
		157
	],
	"./phone-circle.svg": [
		1718,
		158
	],
	"./phone-handset.svg": [
		1719,
		159
	],
	"./phone.svg": [
		1720,
		160
	],
	"./pin.svg": [
		1721,
		161
	],
	"./plus-circle.svg": [
		1722,
		162
	],
	"./plus.svg": [
		1723,
		163
	],
	"./profile.svg": [
		1724,
		164
	],
	"./ribbon-crown.svg": [
		1725,
		165
	],
	"./ribbon-plus.svg": [
		1726,
		166
	],
	"./roots-hair.svg": [
		1727,
		167
	],
	"./salon.svg": [
		1728,
		168
	],
	"./search-2.svg": [
		1729,
		169
	],
	"./search.svg": [
		1730,
		170
	],
	"./settings.svg": [
		1731,
		171
	],
	"./shampoo-and-conditioner.svg": [
		1732,
		172
	],
	"./shield.svg": [
		1733,
		173
	],
	"./shiny-hair.svg": [
		1734,
		174
	],
	"./shop.svg": [
		1735,
		175
	],
	"./spinner-v2-white.svg": [
		1736,
		177
	],
	"./spinner-v2.svg": [
		1737,
		176
	],
	"./star-octagon-filled.svg": [
		1738,
		178
	],
	"./star-octagon.svg": [
		1739,
		179
	],
	"./star.svg": [
		1740,
		180
	],
	"./stars-filled.svg": [
		1741,
		181
	],
	"./stars.svg": [
		1742,
		182
	],
	"./straight-hair.svg": [
		1743,
		183
	],
	"./switch.svg": [
		1744,
		184
	],
	"./tag.svg": [
		1745,
		185
	],
	"./tick.svg": [
		1746,
		186
	],
	"./times-circle-solid.svg": [
		1747,
		187
	],
	"./trash.svg": [
		1748,
		188
	],
	"./truck.svg": [
		1749,
		189
	],
	"./trust.svg": [
		1750,
		190
	],
	"./tube-and-bottle.svg": [
		1751,
		191
	],
	"./tube-and-brush.svg": [
		1752,
		192
	],
	"./tube-and-comb.svg": [
		1753,
		193
	],
	"./tube.svg": [
		1754,
		194
	],
	"./unlimited-roots-membership-comb-icon.svg": [
		1755,
		195
	],
	"./video-camera-light.svg": [
		1756,
		196
	],
	"./video-chat.svg": [
		1757,
		197
	],
	"./video-off.svg": [
		1758,
		198
	],
	"./video.svg": [
		1759,
		199
	],
	"./waving-hand.svg": [
		1760,
		200
	],
	"./wavy-hair.svg": [
		1761,
		201
	],
	"./x-rounded.svg": [
		1762,
		202
	],
	"./zoom-in.svg": [
		1763,
		203
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1140;
module.exports = webpackAsyncContext;